import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { FormattedPriceCalculationResponse } from "../constants";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";
import { UserTierTeam24 } from "./user-tier-team24";

const annualContainerStyles = css(centerJustifiedStyling);

const annualDescriptionStyles = css({
    fontSize: "14px",
    lineHeight: "24px"
});

const userTierContainerStyles = css({
    margin: "4px 0 32px"
});

export type AnnualTeam24Props = {
    readonly priceCalc: FormattedPriceCalculationResponse;
    readonly fontSize: string;
    readonly planName: string;
};

export const AnnualTeam24 = ({
    priceCalc,
    fontSize,
    planName
}: AnnualTeam24Props) => {
    return (
        <Fragment>
            <PriceDisplay
                planName={planName}
                formattedPrice={priceCalc.formattedTotalPrice}
                fontSize={fontSize}
            />
            <div css={annualContainerStyles}>
                <div css={annualDescriptionStyles}>
                    <FormattedMessage
                        id="Pricing.PriceCard.Annual.Description"
                        defaultMessage="per year"
                    />
                </div>
                <div css={userTierContainerStyles}>
                    <UserTierTeam24 priceCalc={priceCalc} />
                </div>
            </div>
        </Fragment>
    );
};
